module.exports = __webpack_public_path__ + "img/sebrae_turismo_nome.25919ed3.png";